export const animation = {
  duration: {
    fast: '0.2s',     // Micro-interactions: hover, focus, tooltips
    normal: '0.3s',   // Standard transitions: buttons, cards
    slow: '0.4s',     // Page/modal transitions, fade-ins
    spinner: '0.8s',  // Loading spinners
  },
  easing: {
    default: 'ease',
    easeOut: 'ease-out',
    easeIn: 'ease-in',
    easeInOut: 'ease-in-out',
    linear: 'linear',
  },
} as const;
